// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2EDXN","colMin":"styles_colMin__1Oy_B","colCheckbox":"styles_colCheckbox__1dh2x"};